module.exports = __webpack_public_path__ + "static/achievement-2-e6ae6dfa602e7e210f292cd0d751c5fa.svg";